import { Injectable } from '@angular/core';
import { UnespCoreUserService } from '@unesp/core';
import { BehaviorSubject } from 'rxjs';
import { UsuarioLogin } from 'src/app/models/usuario-login.model';


/**
 * @description
 *
 * Serviço responsável por manter e disponibilizar o
 * usuário personalizado para uso na aplicação
 *
 */
 @Injectable({
  providedIn: 'root'
})
export class UserLoginService {

  constructor(
    private unespCoreUserService: UnespCoreUserService
  ) {
    this.unespCoreUserService.user$.subscribe(
      (user) => {
        this._userLogin$.next(user as UsuarioLogin);
        localStorage.setItem(this.unespCoreUserService.userKey, JSON.stringify(user));
      }
    );
  }

  private _userLogin$ = new BehaviorSubject<UsuarioLogin | null>(null);

  get user$(): BehaviorSubject<UsuarioLogin | null> {
    return this._userLogin$;
  }

  getUser(): UsuarioLogin | null {
    return this.unespCoreUserService.getUser() as UsuarioLogin;
  }


}
